<template>
  <BackgroundImageComponent img-name="147.jpg"></BackgroundImageComponent>
  <div class="container mt-4 position-relative">
    <div class="card mb-4">
      <div class="card-body">
        <h1 class="text-ruderclub-orange">Rudertechnik</h1>
      </div>
    </div>

    <div class="row">
      <div
        class="col-12 col-md-6 mb-4"
        v-for="(hilfeVideo, hilfeVideoIndex) in hilfeVideos"
        :key="hilfeVideoIndex"
      >
        <div class="card border-ruderclub-dark-green">
          <div class="card-header bg-ruderclub-dark-green">
            <h3 class="card-title mb-0 text-ruderclub-orange">
              {{ hilfeVideo.titel }}
            </h3>
          </div>
          <div class="card-body">
            <iframe
              class="w-100"
              :src="
                'https://www.youtube.com/embed/' +
                hilfeVideo.videoId +
                '?enablejsapi=1&rel=0'
              "
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>

            <div v-if="hilfeVideo.beschreibung">
              <hr />
              <ul>
                <li
                  v-for="(zeile, zeileIndex) in hilfeVideo.beschreibung"
                  :key="zeileIndex"
                >
                  <div v-html="zeile"></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackgroundImageComponent from "@/components/Shared/BackgroundImageComponent.vue";

export default {
  components: { BackgroundImageComponent },
  data() {
    return {
      hilfeVideos: [
        {
          titel:
            "⚠️ RUDERGERÄT FEHLER: Einsteiger machen das falsch + Übung für zu Hause",
          url: "https://www.youtube.com/watch?v=_e1bkp0W7s0",
          videoId: "_e1bkp0W7s0",
          beschreibung: [
            "<b>Haltungsfehler und Auswirkungen:</b>",
            'Durch falsche Technik ("reißen") übermüdet die Bauchmuskulatur schnell, wodurch es zu Haltungsfehlern kommt.',
            "Bandscheibenüberlastung durch Übermüdung der Bauchmuskeln und daraus resultierende Haltungsfehler vermeiden.",
            "<b>Haltungstipps:</b>",
            "Sitzhaltung in der Auslage: aufrechte Sitzhaltung, gerader Rücken.",
            "Technik aus der Rücklage: Hände raus, Oberkörper vorkippen, bis der Griff auf Höhe der Knie ist, und dann nach vorne rollen.",
            "Technik beim Abstoßen: Aus den Beinen drücken – NICHT ruckartig ziehen!",
            "Eintritt in die Rücklage: Erst im letzten Drittel des Zurückrollens die Schulter hinter die Hüfte bringen.",
            "<b>Helferlein: Schlagaufbau</b>",
            "Zu Beginn des Trainings: IMMER Schlagaufbau machen.",
            "Im aufrechten Sitzen erst nur aus den Armen, dann Arme + Oberkörper, dann sukzessive den Ruderschlag aufbauen.",
            "<b>Allgemeine Tipps:</b>",
            "Durchgehend auf die Körperspannung und den Beinschub achten!",
            "Aktives Aufrichten in der Rücklage: ganz hinten aktiv das Becken nach vorne kippen, mit den Zehenspitzen an den Schlaufen ziehen und sich aufrichten.",
            "Bodenübung ab Minute 15:53 im Video, um das aktive Aufrichten zu trainieren.",
          ],
        },
        {
          titel: "⚠️ 5 Fehler, die du auf dem Rudergerät vermeiden solltest",
          url: "https://www.youtube.com/watch?v=0jyDbgMlbyk",
          videoId: "0jyDbgMlbyk",
          beschreibung: [
            "<b>Häufige Fehler:</b>",
            "Widerstand initial zu hoch gesetzt – Widerstand von 4-6 ist perfekt für das reguläre Training.",
            "Hände werden über die Knie gehoben.",
            "Oberkörper liegt 'vorne auf'.",
            "<b>Reihenfolge-Mantra (Vorrollen):</b> Hände, Oberkörper <i>(Spannung im Lendenwirbel halten, Becken kippen)</i>, Anrollen.",
            "Zug über den Spann des Fußes.",
            "Blickrichtung: gerade nach vorne.",
            "Erst wenn die Hände über den Knien sind, nach vorne rollen.",
            "<b>Reihenfolge-Mantra (Zurückrollen):</b> Beine drücken zuerst, Oberkörper neigt sich nach hinten (bleibt aber gerade & Arme bleiben lang), Arme ziehen zu Ende.",
            "<b><i>Ballerina-Fehler:</i></b> Abdrücken muss über den ganzen Fuß erfolgen und nicht nur über den Fußballen vorne.",
            "In der Rücklage: Rücken ist gerade, Ellenbogen sind leicht nach außen geklappt, und der Griff ist unterhalb der Brust dicht am Körper.",
          ],
        },
        {
          titel: "15 Minuten Allround-Workout",
          videoId: "kzTCO1Jb-Z4",
          url: "https://www.youtube.com/watch?v=kzTCO1Jb-Z4",
          beschreibung: [
            "Das Video findest Du auch im Bereich 'Trainieren' mit dem Tag 'Training'",
          ],
        },
        {
          titel: "15 Minuten Fettverbrennung",
          videoId: "FMjNSzs81bs",
          url: "https://www.youtube.com/watch?v=FMjNSzs81bs",
          beschreibung: [
            "Das Video findest Du auch im Bereich 'Trainieren' mit dem Tag 'Training'",
          ],
        },
      ],
    };
  },
};
</script>

<style scoped></style>
